"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("CustomersService", ["ApiService", "$rootScope", function (ApiService, $rootScope) {
  var that = this;

  var params = {
    name: "customers",
    attributesForCache: ["name", "active", "defaultManagerLabel", "qseManagerLabel", "qseManagerHidden", "rhManagerLabel", "rhManagerHidden", "fleetManagerLabel", "fleetManagerHidden", "other1ManagerLabel", "other1ManagerHidden", "other2ManagerLabel", "other2ManagerHidden", "reminderByPositionCancel", "reminderByUserCancel", "reminderByEmailPhoneToUseCancel", "reminderByPositionDepa1", "reminderByPositionDepa2", "reminderByPositionDepa3", "reminderByUserDepa1", "reminderByUserDepa2", "reminderByUserDepa3", "reminderByEmailPhoneToUse1", "reminderByEmailPhoneToUse2", "reminderByEmailPhoneToUse3", "reminderByPositionReport", "reminderByUserReport", "reminderByEmailPhoneToUseReport", "_leadIds", "_drmRespIds", "withExternalVehicle", "fleetTypes", "comFleetTypes", "videoOnlyGroupIds"],
    formatName: function formatName(element) {
      return element ? element.name : "???";
    }
    //defaultOrder: {name: 1},
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.simplifyString = function (value) {
    var r = _.deburr(value).toLowerCase().replace(/\W/g, "").replace(/\s/g, "");

    return r;
  };

  that.addGroup = function (groups, parentId, group) {
    var _this = this;

    //console.log('find parent Id ' + parentId)

    var listChildren = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(node) {
        var index, element;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(node._id == parentId)) {
                  _context.next = 3;
                  break;
                }

                //console.log('find it...')
                node.childrens.push(group);
                return _context.abrupt("return");

              case 3:

                if (node.childrens && node.childrens.length) {
                  for (index = 0; index < node.childrens.length; index++) {
                    element = node.childrens[index];


                    listChildren(element);
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function listChildren(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    if (groups) {
      for (var index = 0; index < groups.length; index++) {
        listChildren(groups[index]);
      }
    }

    return groups;
  };

  that.getSelectArray = function () {
    var withInactive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return new Promise(function (resolve, reject) {
      that.find({
        filter: {
          where: withInactive ? {} : { active: { $ne: false } },
          fields: {
            _id: true,
            name: true,
            active: true,
            defaultManagerLabel: true,
            rhManagerLabel: true,
            rhManagerHidden: true,
            qseManagerLabel: true,
            qseManagerHidden: true,
            fleetManagerLabel: true,
            fleetManagerHidden: true,
            other1ManagerLabel: true,
            other1ManagerHidden: true,
            other2ManagerLabel: true,
            other2ManagerHidden: true
          },
          order: { name: 1 }
        }
      }).then(function (values) {
        var array = [];

        for (var index = 0; index < values.length; index++) {
          var response = values[index];

          array.push({
            name: response.name,
            value: "$" + response._id,
            active: response.active,
            defaultManagerLabel: response.defaultManagerLabel,
            rhManagerLabel: response.rhManagerLabel,
            rhManagerHidden: response.rhManagerHidden,
            qseManagerLabel: response.qseManagerLabel,
            qseManagerHidden: response.qseManagerHidden,
            fleetManagerLabel: response.fleetManagerLabel,
            fleetManagerHidden: response.fleetManagerHidden,
            other1ManagerLabel: response.other1ManagerLabel,
            other1ManagerHidden: response.other1ManagerHidden,
            other2ManagerLabel: response.other2ManagerLabel,
            other2ManagerHidden: response.other2ManagerHidden
          });
        }

        resolve(array);
      });
    });
  };
}]);